import { render, staticRenderFns } from "./FieldTable.vue?vue&type=template&id=3e874670"
import script from "./FieldTable.vue?vue&type=script&lang=js"
export * from "./FieldTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports